import {GetterTree} from 'vuex';
import {ContentBlockInterface, ContentStateInterface} from '@/store/modules/content/types';
import {RootState} from '@/store/types';

export const getters: GetterTree<ContentStateInterface, RootState> = {
  getContentBlock: (state: ContentStateInterface): any => (blockSlug: string): ContentBlockInterface | undefined => {
    return state.blocks.find((block: ContentBlockInterface) => {
      return block.slug === blockSlug;
    });
  },
  getSteps: (state: ContentStateInterface): any => {
    return state.steps;
  },
};
